import { render, staticRenderFns } from "./EChartsRetentionHeatmap.vue?vue&type=template&id=ca36fa08&scoped=true"
import script from "./EChartsRetentionHeatmap.vue?vue&type=script&lang=js"
export * from "./EChartsRetentionHeatmap.vue?vue&type=script&lang=js"
import style0 from "./EChartsRetentionHeatmap.vue?vue&type=style&index=0&id=ca36fa08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca36fa08",
  null
  
)

export default component.exports